export default [
  {
    path: '/customer-management',
    name: 'customer-management',
    component: () => import('@/views/customer-management/index.vue'),
    redirect: '/customer-management/potential',
    meta: {
      title: '客户管理',
      newTab: true,
      keepAlive: false,
      disableScroll: false,
      broadcast: true,
      icon: 'icon-kehuguanli',
    },
    children: [
      {
        path: 'potential',
        name: 'potential',
        component: () => import('@/views/customer-management/potential.vue'),
        meta: {
          title: '潜在客户',
          newTab: true,
          keepAlive: false,
          disableScroll: false,
          broadcast: true,
        },
      },
      {
        path: 'clinch',
        name: 'clinch',
        component: () => import('@/views/customer-management/clinch.vue'),
        meta: {
          title: '成交客户',
          newTab: true,
          keepAlive: false,
          disableScroll: false,
          broadcast: true,
        },
      },
      {
        path: 'contacts',
        name: 'contacts',
        component: () => import('@/views/customer-management/contacts.vue'),
        meta: {
          title: '全部客户',
          newTab: true,
          keepAlive: false,
          disableScroll: false,
          broadcast: true,
        },
      },
      // 潜在客户跳转发送邮件
      {
        path: 'potentialSendEmail',
        name: 'potentialSendEmail',
        component: () => import('@/views/customer-management/sendEmailcode.vue'),
        meta:{
          unMenu:true,
          activeMenu:'potential',
        }
      },
      // 成交客户跳转发送邮件
      {
        path: 'clinchSendEmail',
        name: 'clinchSendEmail',
        component: () => import('@/views/customer-management/sendEmailcode.vue'),
        meta:{
          unMenu:true,
          activeMenu:'clinch',
        }
      },
      // 全部客户跳转发送邮件
      {
        path: 'contactsSendEmail',
        name: 'contactsSendEmail',
        component: () => import('@/views/customer-management/sendEmailcode.vue'),
        meta:{
          unMenu:true,
          activeMenu:'contacts',
        }
      },
    ],
  },
];
